import { render, staticRenderFns } from "./role-edit-modal.vue?vue&type=template&id=91496a48&"
import script from "./role-edit-modal.vue?vue&type=script&lang=js&"
export * from "./role-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports